import React from "react";
import Button from "~/assets/js/components/Button";
import i18n from "../../Helpers/i18n";
import PropTypes from "prop-types";
import { formatCheckoutPrice } from "../../Format";
import { useSpring, animated, config } from "@react-spring/web";

const StickyFooter = ({
    onClick,
    loading = false,
    totals,
    CTA = "cart.continue",
    disabled = false,
    hidden = false,
}) => {
    const transition = useSpring({
        y: hidden ? 500 : 0,
        opacity: hidden ? 0 : 1,
        config: config.stiff,
    });

    const renderPrice = () => {
        return (
            <div className="button_price">
                {formatCheckoutPrice(totals, 0, "€")}
            </div>
        );
    };

    if (!hidden) {
        return (
            <animated.div
                style={transition}
                id="sticky-footer"
                className="popup__wrapper"
            >
                <Button
                    customStyle={"sticky_footer_price"}
                    disabled={disabled}
                    loading={loading}
                    label={i18n.t(CTA)}
                    onClick={onClick}
                    icon={renderPrice()}
                />
            </animated.div>
        );
    }
    // display nothing if hidden
    return null;
};

StickyFooter.propTypes = {
    totals: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
    onClick: PropTypes.func,
    CTA: PropTypes.string,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    hidden: PropTypes.bool,
};

export default StickyFooter;
